import { Map } from 'react-loadable'

export const prefetch = () =>
  import('./components/Room')

const RoomModule = Map({
  loader: {
    Module: prefetch
  },
  loading: () => null,
  render: ({ Module }, props) => {
    const Component = Module.default
    return <Component {...props} />
  }
})

export const Room = RoomModule
